const serviceAnnoucementKey = process.env.VUE_APP_service_announcement_key
const serviceAnnoucementUrl = process.env.VUE_APP_service_announcement_url

export const getAnnouncements= async () => {
  const options = {
    method: 'GET',
    headers: {
      authorization: serviceAnnoucementKey
    }
  }
  try {
    const url = serviceAnnoucementUrl
    const response = await fetch(url, options)

    if (response && response.status == 200) {
      const data = await response.json()
      return data
    } else {
      throw new Error(response)
    }
  } catch (error) {
    throw new Error(error)
  }
}